import React from 'react';
import { Button, Hr } from 'LocalGluons';
import { Text } from 'react-native';
import { t } from 'Locale';
import { EntitlementsResponse, NativeEntitlementsResponse } from '@24i/st-api-connector';
import detailStyles from '../../Details.jss';
import defaultStyles from './SubscriptionUpgradeButton.jss';

export declare type Entitlements = {
    entitled: boolean | null;
    boldTextString: string | null;
    commonTextString: string;
    action: string;
    screenTemplateIdentificator: string | null;
    templateTextString: string | null;
};
interface SubscriptionUpgradeButtonProps {
    onPress: () => void;
    packageName: () => string;
    showLine: boolean;
    isThirdPartyPlatform: boolean;
    entitlements?: EntitlementsResponse | null;
    nativeEntitlements?: NativeEntitlementsResponse | null;
}

const SubscriptionUpgradeButton = ({
    onPress,
    packageName,
    showLine = false,
    isThirdPartyPlatform = false,
    entitlements,
    nativeEntitlements
}: SubscriptionUpgradeButtonProps): JSX.Element => {
    const title = nativeEntitlements ? (
        <Text>
            {t(nativeEntitlements?.commonTextString)}
            <Text style={defaultStyles.boltText}>{` ${nativeEntitlements?.packageName}`}</Text>
        </Text>
    ) : (
        <Text>
            {t(entitlements?.commonTextString)}
            <Text style={defaultStyles.boltText}>{` ${t(entitlements?.boldTextString)}`}</Text>
        </Text>
    );
    return isThirdPartyPlatform ? (
        <Button
            style={{
                button: detailStyles.button,
                icon: defaultStyles.icon,
                text: defaultStyles.buttonTextVoyo
            }}
            iconName="rent"
            title={title}
            onPress={onPress}
        />
    ) : (
        <>
            <Button
                style={{
                    button: detailStyles.button,
                    icon: defaultStyles.icon,
                    text: defaultStyles.buttonText
                }}
                iconName="rent"
                title={`${t('VOD.UPGRADE_TO_PACKAGE_BTN')} ${packageName}`}
                onPress={onPress}
            />
            <Text style={defaultStyles.title}>{`${t(
                'VOD.UPGRADE_TO_PACKAGE_INFO_TXT'
            )} ${packageName}`}</Text>
            {showLine && <Hr style={{ marginBottom: 20 }} />}
        </>
    );
};

export default SubscriptionUpgradeButton;
